import { PayloadAction } from '@reduxjs/toolkit';

import { AppState, DeviceType } from 'editor/src/store/app/types';

const setCustomerDeviceTypeReducer = (state: AppState, { payload: deviceType }: PayloadAction<DeviceType>) => {
  state.customerDeviceType = deviceType;
};

export default setCustomerDeviceTypeReducer;
